module.exports = __webpack_public_path__ + "static/media/Asset7LateralZ1.11b2643e.png";